import React from 'react';

const Component = props => {
	return (
		<>
			<div className='my-[50px]'>
				<h2 className='text-[30px] md:text-[25px] font-normal mb-[30px] text-[#282e3f]'>
					Présentation personnelle
				</h2>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Maître Maïté ABAD ET ORTEGA a obtenu son Master en Droit en juin 2014 à l'Université de Louvain,
					après y avoir suivi l'intégralité de son cursus universitaire.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Immédiatement, elle s'est inscrite au barreau de Charleroi et a effectué son stage auprès de Maître
					Jean-François GAILLY.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Après son stage, elle a poursuivi sa carrière au sein du cabinet de Maître Jean-François GAILLY et
					d'autres cabinets d'avocats réputés en droit des assurances et en responsabilité civile.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					En 2017, elle a suivi une formation spécialisée en droit des assurances et a obtenu un certificat
					universitaire en pratiques professionnelles des assurances.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Maître Maïté ABAD ET ORTEGA s'est également formée en droit de la jeunesse, particulièrement afin de
					pouvoir assister les mineurs dans les procédures qui les concernent.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Au sein du cabinet GAVA-<i>Lex</i>, elle traite du droit des assurances, de la responsabilité civile
					et de la circulation routière, y compris l'indemnisation du dommage corporel ainsi que du droit
					civil au sens large. Le droit de la Jeunesse fait également partie de ses matières de prédilection.
				</p>
			</div>
		</>
	);
};

export default Component;
